import { render, staticRenderFns } from "./EducationPDFLessons.vue?vue&type=template&id=58a6a8c4&scoped=true&"
import script from "./EducationPDFLessons.vue?vue&type=script&lang=js&"
export * from "./EducationPDFLessons.vue?vue&type=script&lang=js&"
import style0 from "./EducationPDFLessons.vue?vue&type=style&index=0&id=58a6a8c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6a8c4",
  null
  
)

export default component.exports